import { io } from "socket.io-client";

import { config } from "../../../config";

/**
 * Shared Socket.IO connection for chat, mirroring the RN app's client config.
 * The socket.io server runs on the same backend as the REST API, so it points
 * at `config.API_URL`. `autoConnect` is off: the connection is only opened once
 * an authenticated chat screen mounts (or presence is registered), so nothing
 * connects before login.
 */
const socket = io(config.API_URL, {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 10000,
});

export default socket;
